import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle, Grid, TextField
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

export default function FormOnEditRole(props) {
  // const classes = useStyles();
  const { open, handleClose, editData, fetchAPI } = props;
  const { register, handleSubmit, errors, } = useForm();
  const [onError, setOnError] = useState(true)
  const [editDatas, setEditDatas] = useState({
    id: "",
    nama: "",
    deskripsi: "",

  });
  const { nama, deskripsi } = editDatas;

  const onSubmit = async () => {
    await fetchAPI("edit", editDatas);
  };

  useEffect(() => {
    if (editData?.nama === editDatas?.nama &&
      editData?.deskripsi === editDatas?.deskripsi
    ) {
      return setOnError(true)
    }
    return setOnError(false)
  }, [editData, editDatas, onError])

  useEffect(() => {
    if (editData) {
      setEditDatas({
        id: editData.id,
        nama: editData.nama,
        deskripsi: editData.deskripsi,
      });
    }
  }, [editData]);

  const handleFieldChange = (e) => setEditDatas({ ...editDatas, [e.target.name]: e.target.value });

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle id="form-dialog-title">Edit On Role</DialogTitle>
          <DialogContent>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                <TextField
                  id="nama"
                  name="nama"
                  label="Nama Role"
                  error={errors.nama}
                  fullWidth
                  placeholder="Type your Nama"
                  type="string"
                  value={nama}
                  variant="outlined"
                  onChange={handleFieldChange}
                  inputRef={register({
                    required: {
                      value: true,
                      message: "Name tidak boleh kosong",
                    },
                    // pattern: {
                    //   value: /^[a-zA-Z]+$/,
                    //   message: "Name Without Special Character",
                    // },
                    // minLength: {
                    //   value: 4,
                    //   message: " must be at least 4 alphas",
                    // },
                  })}
                  InputLabelProps={{ shrink: true }}
                  helperText={
                    errors.nama && errors.nama.message
                  }
                />
              </Grid>

              {/* Username */}
              <Grid item xs={12} sm={12}>
                <TextField
                  id="deskripsi"
                  name="deskripsi"
                  label="Description"
                  placeholder="Type your deskripsi"
                  type="string"
                  value={deskripsi}
                  variant="outlined"
                  error={errors.deskripsi}
                  onChange={handleFieldChange}
                  fullWidth
                  inputRef={register({
                    required: {
                      value: true,
                      message: "Username tidak boleh kosong",
                    },
                    // minLength: {
                    //   value: 4,
                    //   message: " must be at least 4 alphas",
                    // },
                    // pattern: {
                    //   value: /^[a-zA-Z0-9]{4,15}$/,
                    //   message: "Username without Special Character",
                    // },
                  })}
                  InputLabelProps={{ shrink: true }}
                  helperText={
                    errors.deskripsi && errors.deskripsi.message
                  }
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button type="submit" color="primary" disabled={onError}>
              Save
            </Button>
            <Button onClick={handleClose} color="secondary">
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
